import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { injectPwaMeta } from "./lib/pwaMeta";
import { registerSW } from "./lib/registerSW";

injectPwaMeta();

const el = document.getElementById("root")!;
createRoot(el).render(<App />);

registerSW();
